// extracted by mini-css-extract-plugin
export default {"root":"_1aGC9hdN","disabled":"R67GzQRa"};